import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/api";
import { useAuth } from "@/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        window.history.replaceState(null, "", window.location.pathname);
        setUser(data);
        navigate("/dashboard", { replace: true, state: { user: data } });
      } catch (err) {
        toast.error(formatApiError(err));
        navigate("/login", { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="h-10 w-10 rounded-full border-2 border-brand-red border-t-transparent animate-spin" data-testid="auth-callback-loading" />
    </div>
  );
}
